import React from 'react';
import { HubTemplate } from 'src/templates';
import { Locales } from 'src/lib/constants';
import { getResourcesHubStaticProps } from 'src/lib/resources-page-data';

const ResourcesIndex = (props) => {
  return <HubTemplate {...props} locale={Locales.EN_US} cmsTheme='web 3.0' />;
};

export const getStaticProps = async (ctx) => {
  return getResourcesHubStaticProps({
    locale: Locales.EN_US,
    preview: ctx?.preview,
  });
};

export default ResourcesIndex;
